export default from './account-suspended';



// WEBPACK FOOTER //
// ./app/components/account-suspended/index.js